import { api } from "@/lib/api";

export interface ObligationTask {
  id: string; company_obligation_id: string | null; site_obligation_id: string | null;
  occurrence_id: string | null; title: string; description: string | null;
  due_on: string | null; assigned_user_id: string | null; assigned_user_name: string | null;
  status: "open" | "done"; done_at: string | null; done_by_id: string | null; note: string | null;
}
export interface TaskFilter {
  company_obligation_id?: string; site_obligation_id?: string; occurrence_id?: string;
  assigned_user_id?: string; status?: "open" | "done";
}
export interface TaskInput {
  title: string; description: string | null; due_on: string | null;
  assigned_user_id: string | null; note: string | null;
}
export async function getObligationTasks(params: TaskFilter, signal?: AbortSignal): Promise<ObligationTask[]> {
  return (await api.get<ObligationTask[]>("/obligation-tasks", { params, signal })).data;
}
export async function createObligationTask(payload: TaskInput & Pick<TaskFilter, "company_obligation_id" | "site_obligation_id" | "occurrence_id">): Promise<void> {
  await api.post("/obligation-tasks", payload);
}
export async function updateObligationTask(id: string, payload: Partial<TaskInput>): Promise<void> {
  await api.patch(`/obligation-tasks/${id}`, payload);
}
export async function completeObligationTask(id: string, note: string | null): Promise<void> {
  await api.post(`/obligation-tasks/${id}/complete`, { note });
}
export async function deleteObligationTask(id: string): Promise<void> {
  await api.delete(`/obligation-tasks/${id}`);
}
